<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4">
            <label>{{'mantenimientoProductos.table.producto' | translate}} *</label>
            <input type="text" formControlName="desProductoDefecto">
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{productoId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>

<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event">
</app-toast>